import React from 'react';
import { Avatar, Badge } from 'antd';
import { UserOutlined } from '@ant-design/icons';

export const tableColumnsOfTournamentPlayers = [
  {
    title: 'Oyuncu Listesi',
    dataIndex: 'oyuncu-listesi',
    key: 'oyuncu-listesi',
    render: (user: Users.User) => {
      return (
        <div className="user-list-modal" key={`oyuncu-listesi-${user.id}`}>
          <Badge
            dot={true}
            color={user.buhaftamusait_mi ? '#09ED68' : '#979797'}
            offset={[-15, 25]}
          >
            <Avatar
              src={user?.foto_mini_url}
              style={{ marginRight: '10px' }}
              icon={<UserOutlined />}
            />{' '}
          </Badge>
          {user?.ad} {user?.soyad}
        </div>
      );
    },
  },
];

const createGamesTable = (length: number): any => {
  return Array.from({ length }, (v, i) => i).map(item => {
    return {
      match: {
        id: '',
        turnuva_id: '',
        turnuva_sira_id: item + 1,
        kullanici_t_id: '-',
        kullanici_r_id: '-',
        kullanici_t_adsoyad: '-',
        kullanici_r_adsoyad: '-',
        kul_t_set1: 0,
        kul_t_set2: 0,
        kul_t_set3: 0,
        kul_t_sonuc: 0,
        kul_r_set1: 0,
        kul_r_set2: 0,
        kul_r_set3: 0,
        kul_r_sonuc: 0,
        kort_ad: '-',
        mac_saati: '-',
      },
      offering: {
        ad: '-',
        soyad: '-',
      },
      opponent: {
        ad: '-',
        soyad: '-',
      },
    };
  });
};

export const getTournamentColumns = (
  tournamentGames: Tournaments.Game[],
  users: Users.User[],
  playerCount: number,
  isPartner: boolean,
) => {
  const games = createGamesTable(playerCount - 1).map((item: any, index: number) => {
    const match = tournamentGames.find(game => game.turnuva_sira_id === index + 1);
    if (match) {
      item.match = match;
    }
    const offering = users.find(item => match?.kullanici_t_id === item.id);
    if (offering) {
      item.offering = offering;
    }
    const opponent = users.find(item => match?.kullanici_r_id === item.id);
    if (opponent) {
      item.opponent = opponent;
    }
    const offeringPartner = isPartner
      ? users.find(item => match?.kullanici_t_partner_id === item.id)
      : null;
    if (offeringPartner) {
      item.offeringPartner = offeringPartner;
    }
    const opponentPartner = isPartner
      ? users.find(item => match?.kullanici_r_partner_id === item.id)
      : null;
    if (opponentPartner) {
      item.opponentPartner = opponentPartner;
    }
    return item;
  });

  const columns = [];

  if (games.length) {
    let i = playerCount;
    let k = 0;

    while (i > 1) {
      i = i / 2;
      const data = games.slice(k, i + k);
      columns.push(data);
      k = i + k;
    }
  }

  return columns;
};

export const getChampion = (columns: any, users: Users.User[]) => {
  let champion;
  if (columns.length > 2) {
    const lastGame = columns[columns.length - 1][0];

    if (lastGame?.match.kul_r_sonuc > lastGame?.match.kul_t_sonuc) {
      champion = users.find(item => item.id === lastGame?.match.kullanici_r_id);
    } else if (lastGame?.match.kul_r_sonuc < lastGame?.match.kul_t_sonuc) {
      champion = users.find(item => item.id === lastGame?.match.kullanici_t_id);
    } else {
      champion = null;
    }
  } else {
    champion = null;
  }
  return champion;
};

export const applicationButtonStatus = (
  tournamentParticipate: Tournaments.Participate[],
  userData: Users.User,
): string => {
  const activeUserTournamentDoc = tournamentParticipate?.find(
    item => item.kullanici_id === userData?.id,
  );
  if (activeUserTournamentDoc) {
    return activeUserTournamentDoc?.aktif_mi ? 'PASSIVE' : 'WAITING';
  } else {
    return 'ACTIVE';
  }
};
